import { render, staticRenderFns } from "./app-user.vue?vue&type=template&id=125175b2"
import script from "./app-user.vue?vue&type=script&lang=js"
export * from "./app-user.vue?vue&type=script&lang=js"
import style0 from "./app-user.vue?vue&type=style&index=0&id=125175b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports